import React, { createContext, useContext, useEffect, useState, useRef } from "react";
import { getSlideConfigs } from "../utils/loaderconfigs";

const LoaderConfigContext = createContext(null);

export function LoaderConfigProvider({ children }) {
	const [slide, setSlide] = useState(null);
	const [shortCode, setShortCode] = useState(null);
 
  //Grab loader configs for slide first
  	useEffect(() => {
		getSlideConfigs().then(async (slideObj) => {
			setSlide(slideObj);
			// Get loaderConfigs and shortCode as soon as possible
			const loaderConfigs = await slideObj.getLoaderConfig();

			setShortCode(loaderConfigs?.shortCode.toUpperCase() || null);
		});
	}, []);

  // This function can be used anywhere via context
  const sendWithLoaderConfig = async (data, type) => {

	// Don't send to datadrop if the env var is set to false
	if (process.env.REACT_APP_SEND_DATA_TO_DATA_DROP === 'false') {
		return;
	}

    if (!slide) {
      throw new Error("slide not loaded yet");
    }

	const loaderConfigs = await slide.getLoaderConfig();

	// Don't attempt if no short code
	if (!loaderConfigs?.shortCode) {
		return;
	}

	const success = await slide.report(
		{
			source: 'citymotion-webapp',
			version: '1',
			type: type,
			metadata: {
				url: window.location.href,
				appName: 'Citymotion-Webapp',
				appVersion: 1,
				isoDate: new Date().toISOString(),
			},
			data: {
				...data,
				...loaderConfigs,
			}
		},
		loaderConfigs?.shortCode
	).then(resp => {
		return resp
	})

	return success;
  };

  return (
    <LoaderConfigContext.Provider value={{ sendWithLoaderConfig, shortCode }}>
      {children}
    </LoaderConfigContext.Provider>
  );
}

export function useLoaderConfigs() {
  const context = useContext(LoaderConfigContext);
  return context?.loaderConfigs;
}

export function useSendWithLoaderConfig() {
  const context = useContext(LoaderConfigContext);
  return context?.sendWithLoaderConfig;
}

export function useShortCode() {
    const context = useContext(LoaderConfigContext);
    return context?.shortCode;
}
